import React from 'react';
import { node } from 'prop-types';
import { Box, Inline } from '@styleseat/ui';

export default function FormButtonRow({ children }) {
  return (
    <Inline justifyContent="center" alignItems="center" style={{ padding: 12 }}>
      {React.Children.map(children, (child, index) => (
        <Box paddingRight={(index === children.length - 1) ? 0 : 12}>
          {child}
        </Box>
      ))}
    </Inline>
  );
}

FormButtonRow.propTypes = {
  children: node,
};

FormButtonRow.defaultProps = {
  children: null,
};
